import { Component, OnInit } from '@angular/core';
import { Globals } from 'src/app/shared/services/globals';

@Component({
  selector: 'app-auth-home',
  templateUrl: './auth-home.component.html',
  styleUrls: ['./auth-home.component.css']
})
export class AuthHomeComponent implements OnInit {

  constructor(public global: Globals) { }

  ngOnInit() {
    
  }

}
